import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vdmar_panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", null, "ГЕНЕРАТОР GUID", -1)
const _hoisted_3 = { class: "generate_button_div" }
const _hoisted_4 = {
  key: 0,
  class: "vdmar-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", {
      class: "vdmar_fieldset",
      style: _normalizeStyle(_ctx.styleObject)
    }, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.guidParams.hyphens) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.guidParams.hyphens]
        ]),
        _createTextVNode(" Разделить дефисами ")
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.guidParams.braces) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.guidParams.braces]
        ]),
        _createTextVNode(" Заключить в фигурные скобки ")
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" Количество GUID:"),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.guidParams.guidsCount) = $event)),
          maxlength: "2",
          size: "2",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkGuidsCount()))
        }, null, 544), [
          [_vModelText, _ctx.guidParams.guidsCount]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "button",
          class: "generate_button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generateGuid())),
          value: "Создать GUID"
        })
      ]),
      (_ctx.guids.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guids, (guid, item) => {
              return (_openBlock(), _createElementBlock("tr", { key: item }, [
                _createElementVNode("td", null, _toDisplayString(guid), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}